@if (closures.length) {
    <div class="alert alert-warning" role="status">
        <h2 class="h6 mt-0">Closed dates</h2>
        @if (isStaff) {
            <p class="small mb-2">
                These places are closed to permits for the dates below. You are signed in as staff, so a closure will
                <strong>not</strong> stop this application - it is the way to issue a permit for a closed place. Anyone else would be turned away.
            </p>
        } @else {
            <p class="small mb-2">
                These places are currently closed to visitors for the dates below. If you wish to travel during this time, please contact the Tiwi Land Council office.
            </p>
        }
        <ul class="small mb-0 ps-3">
            @for (c of closures; track c.startDate + c.locationId) {
                <li>
                    <strong>{{ label(c) }}</strong> - {{ c.startDate | date: 'd MMM y' }} to {{ c.endDate | date: 'd MMM y' }}
                </li>
            }
        </ul>
    </div>
}
